import type { KeyBinding } from './types';

export const defaultKeybindings: KeyBinding[] = [
  // Node creation
  { key: 'Tab', commandId: 'node.addChild', normalModeOnly: true },
  { key: 'Tab', shift: true, commandId: 'node.addChildAbove', normalModeOnly: true },
  { key: 'Enter', commandId: 'node.addSiblingBelow', normalModeOnly: true },
  { key: 'Enter', shift: true, commandId: 'node.addSiblingAbove', normalModeOnly: true },

  // Node editing
  { key: 'F2', commandId: 'node.editText', normalModeOnly: true },
  { key: ' ', commandId: 'node.editText', normalModeOnly: true },
  { key: 'Escape', commandId: 'node.stopEditing' },
  { key: 'Delete', commandId: 'node.delete', normalModeOnly: true },
  { key: 'Backspace', commandId: 'node.delete', normalModeOnly: true },

  // Node movement
  { key: 'ArrowUp', ctrl: true, commandId: 'node.moveUp', normalModeOnly: true },
  { key: 'ArrowDown', ctrl: true, commandId: 'node.moveDown', normalModeOnly: true },

  // Collapse / expand
  { key: '/', commandId: 'node.toggleCollapse', normalModeOnly: true },

  // Navigation (handled directly by canvas, but registered for shortcut overlay)
  { key: 'ArrowUp', commandId: 'nav.up', normalModeOnly: true },
  { key: 'ArrowDown', commandId: 'nav.down', normalModeOnly: true },
  { key: 'ArrowLeft', commandId: 'nav.left', normalModeOnly: true },
  { key: 'ArrowRight', commandId: 'nav.right', normalModeOnly: true },

  // Edit
  { key: 'z', ctrl: true, commandId: 'edit.undo' },
  { key: 'y', ctrl: true, commandId: 'edit.redo' },
  { key: 'z', ctrl: true, shift: true, commandId: 'edit.redo' },

  // View
  { key: '=', ctrl: true, commandId: 'view.zoomIn' },
  { key: '+', ctrl: true, commandId: 'view.zoomIn' },
  { key: '-', ctrl: true, commandId: 'view.zoomOut' },
  { key: '0', ctrl: true, commandId: 'view.fitToScreen' },

  // Search
  { key: 'f', ctrl: true, commandId: 'search.open' },

  // Notes
  { key: 'n', commandId: 'notes.open', normalModeOnly: true },

  // Attachments
  { key: 'a', commandId: 'attachments.open', normalModeOnly: true },

  // AI
  { key: 'i', commandId: 'ai.open', normalModeOnly: true },

  // Clipboard
  { key: 'c', ctrl: true, commandId: 'clipboard.copy', normalModeOnly: true },
  { key: 'x', ctrl: true, commandId: 'clipboard.cut', normalModeOnly: true },
  { key: 'v', ctrl: true, commandId: 'clipboard.paste', normalModeOnly: true },
  { key: 'd', ctrl: true, commandId: 'clipboard.duplicate', normalModeOnly: true },

  // Comments
  { key: 'c', shift: true, commandId: 'comments.open', normalModeOnly: true },

  // Style
  { key: 'b', ctrl: true, commandId: 'style.bold', normalModeOnly: true },
  { key: 'i', ctrl: true, commandId: 'style.toggleItalic', normalModeOnly: true },
  { key: 'u', ctrl: true, commandId: 'style.toggleUnderline', normalModeOnly: true },

  // Connections
  { key: 'c', alt: true, commandId: 'connection.startAdd', normalModeOnly: true },
  { key: 'Escape', commandId: 'connection.cancel' },
];
